import { range, startCase } from 'lodash';
import { isResetProgram } from 'utils/routeHelper';
import { NO_VISIT } from 'utils/patientDetailsVisitInfo';
import { RESETO_WEEKS, RESET_WEEKS } from 'utils/constants';

export interface IHeaderProperty {
  label: string;
  minWidth?: number;
  width: number;
}

export const weekIndices = (): number[] =>
  isResetProgram() ? range(RESET_WEEKS) : range(RESETO_WEEKS);

export const normalizeDaysSinceClinicVisit = (
  daysSinceClinicVisit: Nullable<string | number>,
) => (daysSinceClinicVisit === NO_VISIT ? null : daysSinceClinicVisit);

export const formatWeekHeaders = (): string[] => {
  return weekIndices().map((weekIndex) => `week_${weekIndex + 1}`);
};

export const getHeaderColumns = (): { [key: string]: IHeaderProperty } => {
  let weekRanges: { [key: string]: IHeaderProperty } = {};

  formatWeekHeaders().forEach((v, idx) => {
    weekRanges[v] = {
      label: startCase(v),
      minWidth: 52,
      width: idx < 9 ? 78 : 85,
    };
  });

  return {
    last_name: {
      label: 'Last Name',
      minWidth: 110,
      width: 150,
    },
    first_name: {
      label: 'First Name',
      minWidth: 110,
      width: 150,
    },
    birth_date: {
      label: 'Date of Birth',
      minWidth: 108,
      width: 109,
    },
    email: {
      label: 'Email',
      width: 279,
    },
    clinic: {
      label: 'Clinic',
      minWidth: 125,
      width: 125,
    },
    health_care_provider: {
      label: 'Health Care Provider',
      minWidth: 106,
      width: 154,
    },
    external_ref: {
      label: 'External Patient ID',
      minWidth: 106,
      width: 154,
    },
    rx_created_date: {
      label: 'Rx Created Date',
      minWidth: 106,
      width: 127,
    },
    rx_start_date: {
      label: 'Rx Start Date',
      minWidth: 106,
      width: 111,
    },
    tos_diphi: {
      label: 'TOS / PHI Disclosure',
      width: 151,
    },
    rx_days_remaining: {
      label: 'Rx Days Remaining',
      minWidth: 106,
      width: 144,
    },
    ...weekRanges,
    total_lessons_completed: {
      label: 'Total Lessons Completed',
      minWidth: 115,
      width: 177,
    },
    days_since_clinic_visit: {
      label: 'Days Since Clinic Visit',
      minWidth: 106,
      width: 158,
    },
    rewards_earned_last_7_days: {
      label: 'Rewards Earned (Last 7 Days)',
      minWidth: 128,
      width: 202,
    },
    rewards_earned_total: {
      label: 'Rewards Earned (Total)',
      minWidth: 128,
      width: 168,
    },
  };
};
